import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toast-notification',
  templateUrl: './toast-notification.component.html',
})
export class ToastNotificationComponent {
  @Input() show = false;
  @Input() message = '';
  @Input() isError = false;
  @Output() close = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }
}
